export default __webpack_public_path__ + "static/media/arrow-right.01f5f3eb.svg";